/**
 * Misceláneas — typographic ornaments as SVG.
 *
 * All of these are deliberately low-contrast (opacity 0.2–0.4) and small
 * (8–12px). They mark structure the way a printer's fleuron does, without
 * drawing a single full-width rule.
 */

/** Six-point asterisk (sextile). Section marker. */
export function Asterisk({ className = '', strokeWidth = 1 }) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
      className={className}
      shapeRendering="geometricPrecision"
    >
      <g stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round">
        <line x1="6" y1="0.9" x2="6" y2="11.1" />
        <line x1="1.58" y1="3.45" x2="10.42" y2="8.55" />
        <line x1="1.58" y1="8.55" x2="10.42" y2="3.45" />
      </g>
    </svg>
  );
}

/** Asterism (⁂) — three marks in a trine. Footer ornament. */
export function Asterism({ className = '' }) {
  return (
    <svg
      viewBox="0 0 20 16"
      fill="none"
      aria-hidden="true"
      className={className}
      shapeRendering="geometricPrecision"
    >
      <g fill="currentColor">
        <circle cx="10" cy="3.4" r="1.15" />
        <circle cx="4.6" cy="12.6" r="1.15" />
        <circle cx="15.4" cy="12.6" r="1.15" />
      </g>
    </svg>
  );
}

/** Registration cross (✛). Appears on card hover, print-plate style. */
export function RegistrationMark({ className = '' }) {
  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      aria-hidden="true"
      className={className}
      shapeRendering="geometricPrecision"
    >
      <g stroke="currentColor" strokeWidth="1" strokeLinecap="round">
        <line x1="5" y1="0.8" x2="5" y2="9.2" />
        <line x1="0.8" y1="5" x2="9.2" y2="5" />
      </g>
    </svg>
  );
}

/** Outbound arrow. Replaces the ↗ glyph so it can animate on its own axis. */
export function ArrowUpRight({ className = '' }) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
      className={className}
      shapeRendering="geometricPrecision"
    >
      <g stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.2 8.8 8.8 3.2" />
        <path d="M4.4 3.2H8.8V7.6" />
      </g>
    </svg>
  );
}
